/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF Support
 * This is the API for the portal frontend and serves as the gateway to the backend services.
 * OpenAPI spec version: 1.2.0
 */
import { adapter } from './adapter';
export interface HotelImages {
  hotelId: string;
  /** @minItems 0 */
  images: Image[];
}

export interface Image {
  large: ImageUrl;
  small: ImageUrl;
  categoryCodes?: string[];
  tourOperatorAndSeasons?: TourOperatorAndSeasons[];
}

export interface ImageUrl {
  /** full url to the image, page or whatever */
  url: string;
}

export interface ServiceCenterBenefit {
  icon: string;
  title: string;
  description: string;
}

export interface TourOperatorAndSeasons {
  /** tourOperatorCode */
  tourOperator?: string;
  seasons?: string[];
}

export interface TourOperatorDescriptionResult {
  content?: string;
  title?: string;
}

/**
 * procied smartseer profile
 */
export interface SmartseerProfileResponse {
  /** json string with full raw response from smartseer @see https://docs.smartseer.com/users/v3?trackingId=i15580#/paths/~1users~1v3~1%7BuserId%7D~1profiles~1current/post */
  rawProfile?: string;
}

export interface MetaResponse {
  userCity: string;
}

/**
 * CategoryType describes the category of the hotel.
Verified means we are able to show stars because the hotel is rated by some 3rd party.
Unverified means there is no rating from an external organization available to rely on, so show dots/circles.

 */
export type HotelContentResponseCategoryType = typeof HotelContentResponseCategoryType[keyof typeof HotelContentResponseCategoryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotelContentResponseCategoryType = {
  verified: 'verified',
  unverified: 'unverified',
} as const;

/**
 * Snippets are small texts categorized in sentiments.
 */
export type HotelContentResponseSnippets = {
  pos?: SentimentSnippets;
  neu?: SentimentSnippets;
  neg?: SentimentSnippets;
};

/**
 * Summary is an overview of the latest ratings.
 */
export type HotelContentResponseRelevantNowSummary = {
  score: Percent;
  /** ScoreDescription is a wording to display for the Score. */
  scoreDescription: string;
  /**
   * ReviewCount is a count of how many reviews are taken to calculate that Score.
   * @minimum 1
   */
  reviewCount: number;
  /**
   * Trend describes if the latest reviews are better (1), worse (-1) or same as overall rating.
   * @minimum -1
   * @maximum 1
   */
  trend: number;
};

/**
 * RelevantNow summarizes recent (last 6 months) and relevant feedback for the hotel.
Provided by TrustYou.

 */
export type HotelContentResponseRelevantNow = {
  /** Summary is an overview of the latest ratings. */
  summary: HotelContentResponseRelevantNowSummary;
};

/**
 * contains content for hotel
 */
export interface HotelContentResponse {
  /**
   * Id is the unique identifier of the hotel.
   * @pattern ^\d+-\[a-z]+$
   */
  id: string;
  /** Name of the hotel provided by GIATA. */
  name?: string;
  /** City name the hotel belongs to. */
  city?: string;
  /** Region name the hotel belongs to. */
  region?: string;
  /** Country name the hotel belongs to. */
  country?: string;
  /**
   * Lat is the latitude coordinate of the hotel.
   * @minimum -90
   * @maximum 90
   */
  lat?: number;
  /**
   * Lng is the longitude coordinate of the hotel.
   * @minimum -180
   * @maximum 180
   */
  lng?: number;
  /**
   * Category is the rating in stars or dots/circles for the hotel, based on categoryType.
   * @minimum 0
   */
  category?: number;
  /** CategoryType describes the category of the hotel.
Verified means we are able to show stars because the hotel is rated by some 3rd party.
Unverified means there is no rating from an external organization available to rely on, so show dots/circles.
 */
  categoryType?: HotelContentResponseCategoryType;
  /** The year of the construction of the hotel building. */
  constructionYear?: number;
  /** The year of the last renovation of the hotel building. */
  renovationYear?: number;
  /**
   * ReviewsCount describes how many reviews for the hotel exist to rate the hotel. Provided by TrustYou.
   * @minimum 1
   */
  reviews_count?: number;
  /** Score for the rating in percent, based on user reviews. Exact ratings like "3.1/5" can be calculated.
Provided by TrustYou.
 */
  score?: unknown;
  /** ScoreDescription is some wording for the score. Provided by TrustYou. */
  score_description?: string;
  /** Badge is a wording where the hotel is outstanding. Provided by TrustYou. */
  badge?: string;
  /** Images contains all images for the hotel. */
  images?: HotelImage[];
  /** IsClassicImages determines if the images provided are taken from the classic MasterData (true), or GIATA only (false).
Classic images could be used because of the better quality compared to GIATA content.
 */
  isClassicImages?: boolean;
  /** SummarisingStatement describes the hotel‘s reputation, including remarks about its hotel type and nearby points of interest.
Provided by TrustYou.
 */
  summarisingStatement?: string;
  address?: Address;
  /** BadgeText incorporates the badge's score or rank. Provided by TrustYou. */
  badge_text?: string;
  /** Snippets are small texts categorized in sentiments. */
  snippets?: HotelContentResponseSnippets;
  /** Attributes are groups of hotel attributes, grouped by Invia MainType. */
  attributes?: HotelAttributesGroup[];
  supplierAttributes?: SupplierAttributes;
  /** DescriptionCurated is a general hotel description created by GIATA, independent of any tour operator. */
  descriptionCurated?: DescriptionCuratedItem[];
  /** GoodToKnow contains interesting tidbits about the hotel – infrequent categories that are still characteristic of the hotel.
Provided by TrustYou.
 */
  goodToKnow?: GoodToKnowItem[];
  /** Reviews is a list of ratings for the hotel grouped by different kind of travellers, see TravellerType.
Provided by TrustYou.
 */
  reviews?: Review[];
  /** RelevantNow summarizes recent (last 6 months) and relevant feedback for the hotel.
Provided by TrustYou.
 */
  relevantNow?: HotelContentResponseRelevantNow;
  /** ReviewsLastMonths is a list of how many reviews were made in the last 6 months. */
  reviewsLastMonths?: number[];
  /** Categories contains ratings about cleanliness and health safety. */
  categories?: CategoryWithSubcategories[];
}

/**
 * Short hotel rating object
 */
export interface HotelRatingsResponse {[key: string]: ShortRating}

/**
 * HotelImage is a single hotel image provided in different sizes. May contain only one size.
 */
export interface HotelImage {
  /** Type is probably some code for what the picture shows or where the picture is taken. */
  type: string;
  large?: HotelImageSize;
  small?: HotelImageSize;
}

/**
 * TravellerType describes which kind of travellers this rating is based on. Type _all_ is an overall overview.
 */
export type ReviewTravellerType = typeof ReviewTravellerType[keyof typeof ReviewTravellerType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewTravellerType = {
  all: 'all',
  business: 'business',
  couple: 'couple',
  solo: 'solo',
  family: 'family',
  friends: 'friends',
} as const;

/**
 * Review is an aggregated rating for a specific kind of travellers, see TravellerType.
 */
export interface Review {
  /** TravellerType describes which kind of travellers this rating is based on. Type _all_ is an overall overview. */
  travellerType: ReviewTravellerType;
  /** TravellerTypeTranslation is a wording for the TravellerType to display. */
  travellerTypeTranslation: string;
  score: Percent;
  reviewPercent: Percent;
  /**
   * Categories is a list of detailed reviews by this TravellerType.
   * @minItems 1
   */
  categories: CategoryWithStatements[];
}

/**
 * Category is a rating for a specific topic e.g.  cleanliness or health safety of the hotel.
 */
export interface CategoryWithSubcategories {
  /**
   * ID is the unique identifier to this Category.
   * @minLength 1
   */
  id: string;
  /** Caption is the wording to display the category name. */
  caption: string;
  score: Percent;
  /**
   * ReviewCount is a count of how many reviews are taken to calculate that Score.
   * @minimum 1
   */
  reviewCount: number;
  /** SubCategories give further information about a Category. */
  subCategories?: SubCategory[];
}

/**
 * Category is a rating for a specific topic.
 */
export interface CategoryWithStatements {
  /**
   * ID is the unique identifier to this Category.
   * @minLength 1
   */
  id: string;
  /** Caption is the wording to display the category name. */
  caption: string;
  score: Percent;
  /**
   * ReviewCount is a count of how many reviews are taken to calculate that Score.
   * @minimum 1
   */
  reviewCount: number;
  /** Statements are a few small text snippets for this Category to display. */
  statements?: Statement[];
}

/**
 * SubCategory gives further information about a Category.
 */
export interface SubCategory {
  /**
   * ID is the unique identifier to this Category.
   * @minLength 1
   */
  id: string;
  /** Caption is the wording to display the category name. */
  caption: string;
  score: Percent;
  /**
   * ReviewCount is a count of how many reviews are taken to calculate that Score.
   * @minimum 1
   */
  reviewCount: number;
  /**
   * Text is a short snippet to describe the SubCategory.
   * @minLength 1
   */
  text?: string;
}

/**
 * Sentiment for the text. Is it positive (pos), neutral (neu), negative (neg) or a combination (mixed)?
 */
export type StatementSentiment = typeof StatementSentiment[keyof typeof StatementSentiment];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StatementSentiment = {
  pos: 'pos',
  neu: 'neu',
  neg: 'neg',
  mixed: 'mixed',
} as const;

/**
 * Statement is a small text snippet for the Category to display.
 */
export interface Statement {
  /**
   * Text is a short snippet to describe the Category.
   * @minLength 1
   */
  text: string;
  /** Sentiment for the text. Is it positive (pos), neutral (neu), negative (neg) or a combination (mixed)? */
  sentiment: StatementSentiment;
}

/**
 * SentimentSnippets contains of small texts describing the hotel. used for positive, neutral or negative texts

 * @minItems 1
 */
export type SentimentSnippets = string[];

/**
 * Percent describes a natural number (integer) between 0 and 100. Score for the rating in percent, based on user reviews. Exact ratings like "3.1/5" can be calculated.
 * @minimum 0
 * @maximum 100
 */
export type Percent = number;

/**
 * Sentiment for the tidbit. Is it positive (pos), neutral (neu) or negative (neg)?
 */
export type GoodToKnowItemSentiment = typeof GoodToKnowItemSentiment[keyof typeof GoodToKnowItemSentiment];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GoodToKnowItemSentiment = {
  pos: 'pos',
  neu: 'neu',
  neg: 'neg',
} as const;

/**
 * GoodToKnowItem contains interesting tidbits about the hotel.
 */
export interface GoodToKnowItem {
  /**
   * Text is the actual text about the tidbit.
   * @minLength 1
   */
  text: string;
  /** Sentiment for the tidbit. Is it positive (pos), neutral (neu) or negative (neg)? */
  sentiment: GoodToKnowItemSentiment;
}

/**
 * DescriptionCuratedItem is a section/paragraph of the GIATA hotel description.
 */
export interface DescriptionCuratedItem {
  /**
   * Title is the headline of the section.
   * @minLength 1
   */
  title: string;
  /**
   * Content is the actual text for the section.
   * @minLength 1
   */
  content: string;
}

export interface SupplierAttributeAmenity {
  attributes?: SupplierAttributeAmenityAttribute[];
  id?: string;
  name?: string;
  paid?: boolean;
}

export interface SupplierAttributeAmenityAttribute {
  name?: string;
  type?: string;
  value?: string;
}

export interface SupplierAttributeSection {
  id?: string;
  amenities?: SupplierAttributeAmenity[];
  name?: string;
  sub_sections?: SupplierAttributeSection[];
}

export type SupplierAttributes = SupplierAttributeSection[];

/**
 * HotelAttributesGroup is a single group of hotel attributes, grouped by Invia MainType.
 */
export interface HotelAttributesGroup {
  /**
   * Name is a code for the group.
   * @minLength 1
   */
  name: string;
  /** Translation is a wording to display the group name. */
  translation: string;
  /**
   * Attributes is the actual list of hotel attributes.
   * @minItems 1
   */
  attributes: HotelAttribute[];
}

/**
 * HotelAttribute contains an Invia Type, a translation and optional value.
 */
export interface HotelAttribute {
  /**
   * Name is an Invia Type for the attribute.
   * @minLength 6
   */
  name: string;
  /** Translation is a wording to display the attribute name. */
  translation: string;
  /** Value comes from the GIATA fact.Value for the attribute. */
  value?: string;
}

/**
 * Address describes the complete address of the hotel.
 */
export interface Address {
  /** Country name of the hotel. May be the same as countryCode if we can not translate the code into a name. */
  country?: string;
  /** CountryCode is the 2 letter country code based on ISO-3166. May default to _XU_ if none is available. */
  countryCode?: string;
  /** Region name of the hotel. */
  region?: string;
  /** City name of the hotel. */
  city?: string;
  /** Zip code of the hotel. */
  zip?: string;
  /** Street of the hotel. */
  street?: string;
  /** StreetNumber for the hotel on street. */
  streetNumber?: string;
}

/**
 * HotelImageSize is a hotel image in a certain size. Large image is one of xl, large, medium [provided by Team Re-Source](https://confluence.invia.lan/display/7SE/CDN+-+Pictures), where the order is priority (xl > large > medium).

 */
export interface HotelImageSize {
  /**
   * Url to the hotel image.
   * @minLength 7
   */
  url: string;
}

/**
 * contains a list of hotel images
 */
export interface HotelImagesResponse {
  /** @minItems 0 */
  hotels: HotelImages[];
}

/**
 * service center banner information
 */
export interface ServiceCenterBannerResponse {
  picture?: string;
  title?: string;
  subtitle?: string;
  text?: string;
  phone?: string;
  benefits: ServiceCenterBenefit[];
}

export type TourOperatorDescriptionResponse = TourOperatorDescriptionResult[];

/**
 * contains cee term ID
 */
export interface OfferShortcutResponse {
  termID: string;
}

/**
 * a generic bad request error
 */
export interface BadRequestResponse {
  message: string;
}

/**
 * not found response
 */
export interface NotFoundResponse {
  message: string;
}

/**
 * contains some detailed error information.
 */
export interface ErrorDetail {
  /** the error code. */
  code: number;
  /** the error message. use only for internal evaluation. */
  message: string;
  /**
   * describes a field or parameter this error belongs to. may be null.
   * @nullable
   */
  relate: string | null;
}

/**
 * the container to return error information.
 */
export interface ErrorResponse {
  /** the error code. */
  code: number;
  /** the error message. use only for internal evaluation. */
  message: string;
  'error-details': ErrorDetail[];
}

/**
 * Short hotel rating object
 */
export interface ShortRating {
  /** Rating count */
  count: number;
  /** Rating value */
  rating: number;
  /** Recommendation rate value */
  recommendation: number;
}

/**
 * An error response
 */
export type ErrorResponseResponse = ErrorResponse;

/**
 * A bad request response
 */
export type BadRequestResponseResponse = BadRequestResponse;

/**
 * Not found response
 */
export type NotFoundResponseResponse = NotFoundResponse;

/**
 * defines the region id from autocompleter.
 */
export type DestinationIdParameter = string;

export type DeviceParameter = typeof DeviceParameter[keyof typeof DeviceParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeviceParameter = {
  mobile: 'mobile',
  desktop: 'desktop',
} as const;

export type PageParameter = typeof PageParameter[keyof typeof PageParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PageParameter = {
  offers: 'offers',
  hotels: 'hotels',
} as const;

/**
 * defines the last day of vacation; not always the day of arrival in travellers home.
 */
export type DateMaxParameter = string;

/**
 * defines the first day of vacation.
 */
export type DateMinParameter = string;

/**
 * identificator for hotel, id with suffix to identify source of id
 */
export type HotelParameter = string;

export type TravelTypeParameter = typeof TravelTypeParameter[keyof typeof TravelTypeParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TravelTypeParameter = {
  packageTour: 'packageTour',
  ownArrival: 'ownArrival',
} as const;

/**
 * uuid, identifying the user without knowing his name
 */
export type XUserIdParameter = string;

export type GetHotelContentParams = {
/**
 * identificator for single hotel, id with suffix to identify source of id
 * @pattern ^[0-9]+-giata$
 */
hotel: string;
};

export type GetHotelImagesParams = {
/**
 * identificators for multiple hotels, ids with suffix to identify source of id
 */
hotels: string[];
};

export type GetOfferShortcutParams = {
/**
 * offerID of cee offer
 */
offerID: string;
};

export type GetSmartseerProfileParams = {
/**
 * userID getting from BD4Travel Cookie
 */
BD4ID: string;
};

export type GetHotelRatingsParams = {
/**
 * identificators for multiple hotels, ids with suffix to identify source of id
 */
hotels: string[];
};

export type GetServiceCenterBannerParams = {
/**
 * defines the region id from autocompleter.
 */
destinationId: DestinationIdParameter;
/**
 * defines the device type
 */
device: DeviceParameter;
/**
 * defines the page type
 */
page: PageParameter;
/**
 * defines the travel type.
 */
travelType?: TravelTypeParameter;
};

export type GetTourOperatorDescriptionParams = {
/**
 * identificator for hotel, id with suffix to identify source of id
 * @pattern ^[0-9]+-giata$
 */
hotel: HotelParameter;
tourOperator: string;
/**
 * defines the first day of vacation.
 * @pattern ^\d{4}-\d{2}-\d{2}$
 */
dateMin: DateMinParameter;
/**
 * defines the last day of vacation; not always the day of arrival in travellers home.
 * @pattern ^\d{4}-\d{2}-\d{2}$
 */
dateMax: DateMaxParameter;
/**
 * defines the travel type.
 */
travelType?: TravelTypeParameter;
/**
 * service code from supplier/organizer. is like a hotelCode e.g. 'PMI8774'
 * @nullable
 */
serviceCode?: string | null;
};

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

/**
 * @summary retrieve hotel content from reSource api and return it corresponding to s3/details.schema.yaml
 */
export type getHotelContentResponse200 = {
  data: HotelContentResponse
  status: 200
}

export type getHotelContentResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getHotelContentResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 400>
}
    
export type getHotelContentResponseComposite = getHotelContentResponse200 | getHotelContentResponse400 | getHotelContentResponseDefault;
    
export type getHotelContentResponse = getHotelContentResponseComposite & {
  headers: Headers;
}

export const getGetHotelContentUrl = (params: GetHotelContentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/hotel-content?${stringifiedParams}` : `/hotel-content`
}

export const getHotelContent = async (params: GetHotelContentParams, options?: RequestInit): Promise<getHotelContentResponse> => {
  
  return adapter<getHotelContentResponse>(getGetHotelContentUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary retrieve image urls from reSource image api
 */
export type getHotelImagesResponse200 = {
  data: HotelImagesResponse
  status: 200
}

export type getHotelImagesResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getHotelImagesResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 400>
}
    
export type getHotelImagesResponseComposite = getHotelImagesResponse200 | getHotelImagesResponse400 | getHotelImagesResponseDefault;
    
export type getHotelImagesResponse = getHotelImagesResponseComposite & {
  headers: Headers;
}

export const getGetHotelImagesUrl = (params: GetHotelImagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/images?${stringifiedParams}` : `/images`
}

export const getHotelImages = async (params: GetHotelImagesParams, options?: RequestInit): Promise<getHotelImagesResponse> => {
  
  return adapter<getHotelImagesResponse>(getGetHotelImagesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary get service independent information
 */
export type getMetaResponse200 = {
  data: MetaResponse
  status: 200
}

export type getMetaResponse204 = {
  data: null
  status: 204
}
    
export type getMetaResponseComposite = getMetaResponse200 | getMetaResponse204;
    
export type getMetaResponse = getMetaResponseComposite & {
  headers: Headers;
}

export const getGetMetaUrl = () => {


  

  return `/meta`
}

export const getMeta = async ( options?: RequestInit): Promise<getMetaResponse> => {
  
  return adapter<getMetaResponse>(getGetMetaUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary get term information for cee
 */
export type getOfferShortcutResponse200 = {
  data: OfferShortcutResponse
  status: 200
}
    
export type getOfferShortcutResponseComposite = getOfferShortcutResponse200;
    
export type getOfferShortcutResponse = getOfferShortcutResponseComposite & {
  headers: Headers;
}

export const getGetOfferShortcutUrl = (params: GetOfferShortcutParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/offer-shortcut?${stringifiedParams}` : `/offer-shortcut`
}

export const getOfferShortcut = async (params: GetOfferShortcutParams, options?: RequestInit): Promise<getOfferShortcutResponse> => {
  
  return adapter<getOfferShortcutResponse>(getGetOfferShortcutUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary get current profile for tracked customer
 */
export type getSmartseerProfileResponse200 = {
  data: SmartseerProfileResponse
  status: 200
}

export type getSmartseerProfileResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getSmartseerProfileResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 400>
}
    
export type getSmartseerProfileResponseComposite = getSmartseerProfileResponse200 | getSmartseerProfileResponse400 | getSmartseerProfileResponseDefault;
    
export type getSmartseerProfileResponse = getSmartseerProfileResponseComposite & {
  headers: Headers;
}

export const getGetSmartseerProfileUrl = (params: GetSmartseerProfileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/profile?${stringifiedParams}` : `/profile`
}

export const getSmartseerProfile = async (params: GetSmartseerProfileParams, options?: RequestInit): Promise<getSmartseerProfileResponse> => {
  
  return adapter<getSmartseerProfileResponse>(getGetSmartseerProfileUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary retrieve ratings urls from reSource review api
 */
export type getHotelRatingsResponse200 = {
  data: HotelRatingsResponse
  status: 200
}

export type getHotelRatingsResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getHotelRatingsResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 400>
}
    
export type getHotelRatingsResponseComposite = getHotelRatingsResponse200 | getHotelRatingsResponse400 | getHotelRatingsResponseDefault;
    
export type getHotelRatingsResponse = getHotelRatingsResponseComposite & {
  headers: Headers;
}

export const getGetHotelRatingsUrl = (params: GetHotelRatingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/ratings?${stringifiedParams}` : `/ratings`
}

export const getHotelRatings = async (params: GetHotelRatingsParams, options?: RequestInit): Promise<getHotelRatingsResponse> => {
  
  return adapter<getHotelRatingsResponse>(getGetHotelRatingsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary Get service center banner
 */
export type getServiceCenterBannerResponse200 = {
  data: ServiceCenterBannerResponse
  status: 200
}

export type getServiceCenterBannerResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getServiceCenterBannerResponse404 = {
  data: NotFoundResponseResponse
  status: 404
}

export type getServiceCenterBannerResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 400 | 404>
}
    
export type getServiceCenterBannerResponseComposite = getServiceCenterBannerResponse200 | getServiceCenterBannerResponse400 | getServiceCenterBannerResponse404 | getServiceCenterBannerResponseDefault;
    
export type getServiceCenterBannerResponse = getServiceCenterBannerResponseComposite & {
  headers: Headers;
}

export const getGetServiceCenterBannerUrl = (params: GetServiceCenterBannerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/service-center-banner?${stringifiedParams}` : `/service-center-banner`
}

export const getServiceCenterBanner = async (params: GetServiceCenterBannerParams, options?: RequestInit): Promise<getServiceCenterBannerResponse> => {
  
  return adapter<getServiceCenterBannerResponse>(getGetServiceCenterBannerUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



/**
 * @summary get tour operator description for a hotel
 */
export type getTourOperatorDescriptionResponse200 = {
  data: TourOperatorDescriptionResponse
  status: 200
}

export type getTourOperatorDescriptionResponse204 = {
  data: null
  status: 204
}

export type getTourOperatorDescriptionResponse400 = {
  data: BadRequestResponseResponse
  status: 400
}

export type getTourOperatorDescriptionResponseDefault = {
  data: ErrorResponseResponse
  status: Exclude<HTTPStatusCodes, 200 | 204 | 400>
}
    
export type getTourOperatorDescriptionResponseComposite = getTourOperatorDescriptionResponse200 | getTourOperatorDescriptionResponse204 | getTourOperatorDescriptionResponse400 | getTourOperatorDescriptionResponseDefault;
    
export type getTourOperatorDescriptionResponse = getTourOperatorDescriptionResponseComposite & {
  headers: Headers;
}

export const getGetTourOperatorDescriptionUrl = (params: GetTourOperatorDescriptionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tour-operator-description?${stringifiedParams}` : `/tour-operator-description`
}

export const getTourOperatorDescription = async (params: GetTourOperatorDescriptionParams, options?: RequestInit): Promise<getTourOperatorDescriptionResponse> => {
  
  return adapter<getTourOperatorDescriptionResponse>(getGetTourOperatorDescriptionUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
